// Market-data import — PSD §10.2 (F10.2). Integration layer.
// File-based volatility / risk-free / multiples.

export interface MarketDataBundle {
  volatility: number | null;
  riskFreeRate: number | null;
  multiples: { name: string; value: number }[];
  warnings: string[];
}

/** Parse a market-data JSON file into a bundle. */
export async function parseMarketData(file: File): Promise<MarketDataBundle> {
  const text = await file.text();
  const warnings: string[] = [];
  let parsed: Record<string, unknown>;
  try {
    parsed = JSON.parse(text);
  } catch {
    // Try CSV for multiples
    const lines = text.trim().split(/\r?\n/);
    const multiples: { name: string; value: number }[] = [];
    for (let i = 1; i < lines.length; i++) {
      const [name, val] = lines[i]!.split(',');
      if (name && val) multiples.push({ name: name.trim(), value: parseFloat(val) || 0 });
    }
    return { volatility: null, riskFreeRate: null, multiples, warnings: ['Parsed as CSV multiples'] };
  }

  return {
    volatility: typeof parsed.volatility === 'number' ? parsed.volatility : null,
    riskFreeRate: typeof parsed.riskFreeRate === 'number' ? parsed.riskFreeRate : null,
    multiples: Array.isArray(parsed.multiples)
      ? (parsed.multiples as { name: string; value: number }[])
      : [],
    warnings,
  };
}
